import Axios from 'axios';
import axios, { AxiosInstance } from 'axios';
import { API_URL } from './config.ts';

export const setAxiosOnError = (handler: (error: any) => void) => {
  axiosOnError = handler;
};

let axiosOnError: (error: any) => void;

const installResponseInterceptor = (client: AxiosInstance) => {
  client.interceptors.response.use(
    (response) => {
      if (response.status === 204) {
        // Normalize empty responses
        response.data = undefined;
      }
      return response;
    },
    (error) => {
      const isAuthUser = error?.request?.responseURL?.includes('/auth/user');
      const status = error?.response?.status;
      if (status !== 401 && !isAuthUser && !error.config?.skipGlobalErrorHandler) {
        if (axiosOnError) {
          axiosOnError(error);
        }
      } else if (status === 401 || isAuthUser) {
        // Avoid redirect loop while on /login or during auth/user calls
        const onLogin = window.location.pathname === '/login';
        const isAuthUser = error?.request?.responseURL?.includes('/auth/user');
        const isOnContractSignPage = window.location.pathname.startsWith('/contract-sign');
        if (!onLogin && !isAuthUser && !isOnContractSignPage) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );
};

const buildHttpClient = ({ baseUrl = '' }): AxiosInstance => {
  const httpClient = Axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    paramsSerializer: {
      indexes: null
    }
  });

  installResponseInterceptor(httpClient);

  return httpClient;
};

const axiosClient = buildHttpClient({ baseUrl: API_URL });

export const getAxios = () => {
  return axiosClient;
};

export const configGlobalAxios = () => {
  axios.defaults.baseURL = API_URL;
  axios.defaults.withCredentials = true;
  installResponseInterceptor(axios);
};
